// extracted by mini-css-extract-plugin
export default {"header":"Dashboard_header__LIKUt","trisect":"Dashboard_trisect__EXnfK"};